import { useSubtotals } from '../../context/SubtotalsProvider';
import RecurringSubscriptionSubtext from '../RecurringSubscriptionSubtext';
import { jsx as _jsx } from "react/jsx-runtime";
const AchFuturePaymentsMessage = ({
  currencyCode
}) => {
  const {
    recurringSubtotals = [],
    loading
  } = useSubtotals();
  if (loading) {
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "ach-future-payments-message-loading"
    });
  }
  if (recurringSubtotals.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx("span", {
    "data-test-id": "ach-future-payments-message",
    children: recurringSubtotals.map((recurringSubtotal, idx) => /*#__PURE__*/_jsx(RecurringSubscriptionSubtext, {
      currencyCode: currencyCode,
      recurringSubtotal: recurringSubtotal,
      shortenDescription: true
    }, idx))
  });
};
export default AchFuturePaymentsMessage;